import { Reducer } from "redux";
import {
  ClientCustomerAction,
  ClientCustomerActionType,
  ICallbackGetCustomerAction,
} from "../action/client_customer_action";
import { ClientCustomerState } from "../store/client_customer_state";

const initialState: ClientCustomerState = {
  customer: null,
  jobCareers: [],
  company: null,
  isLoading: false,
  pastCaseProjects: [],
};

const clientCustomerReducer: Reducer<ClientCustomerState> = (
  state = initialState,
  action: ClientCustomerAction
): ClientCustomerState => {
  switch (action.type) {
    case ClientCustomerActionType.REQUEST_GET_CUSTOMER: {
      return Object.assign({}, state, {
        isLoading: true,
      });
    }
    case ClientCustomerActionType.CALLBACK_GET_CUSTOMER: {
      const _action = action as ICallbackGetCustomerAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          customer: _action.item ? _action.item.customer : null,
          jobCareers: _action.item ? _action.item.jobCareer : null,
          company: _action.item ? _action.item.company : null,
          isLoading: false,
          pastCaseProjects: _action.item ? _action.item.postCaseProjects : [],
        });
      } else {
        return Object.assign({}, state, {
          isLoading: false,
        });
      }
    }

    default:
      return state;
  }
};

export default clientCustomerReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_customer_reducer.ts